import React from "react";
import PropTypes from "prop-types";

import { Icon, Label } from "semantic-ui-react";

export default function ClearFilters({ onClick }) {
  return (
    <span
      style={{ marginLeft: "1em" }}
      data-test="clear-all-filters"
      key="delete-label"
    >
      <Label color="yellow" onClick={onClick}>
        Clear all
        <Icon name="delete" />
      </Label>
    </span>
  );
}

ClearFilters.propTypes = {
  onClick: PropTypes.func.isRequired,
};
